/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import i18next from 'i18next';

export const all = () => () => {
  // Some validations may come in the future
  return true;
};

/* Fields By Presence */
export const required = (fieldName = 'validation.the.field') => (value) => {
  if (!/^.+$/.test(value))
    return i18next.t('validation.default.required', { error: { property: i18next.t(fieldName) } });
  return true;
};

export const optional = () => () => {
  // Some validations may come in the future
  return true;
};

/* Fields By Format */
export const integer = (min, max) => (value) => {
  if (value && value.length) {
    if (!/^[+-]?\d+$/.test(value)) return i18next.t('validation.number.invalid.format');
    if (Number.isNaN(Number.parseInt(value))) return i18next.t('validation.number.invalid.format');
    if (Number.parseInt(value) < min) return i18next.t('validation.number.min.value.allowed', { value: min });
    if (Number.parseInt(value) > max) return i18next.t('validation.number.max.value.allowed', { value: max });
  }
  return true;
};

export const decimal = (min, max) => (value) => {
  if (value && value.length) {
    if (!/^[+-]?\d+\.\d+$/.test(value)) return i18next.t('validation.number.invalid.format');
    if (Number.isNaN(Number.parseFloat(value))) return i18next.t('validation.number.invalid.format');
    if (Number.parseFloat(value) < min) return i18next.t('validation.number.min.value.allowed', { value: min });
    if (Number.parseFloat(value) > max) return i18next.t('validation.number.max.value.allowed', { value: max });
  }
  return true;
};

export const text = (minLength, maxLength) => (value) => {
  if (value && value.length) {
    if (value.length < minLength) return i18next.t('validation.default.minlength', { error: { limit: minLength } });
    if (value.length > maxLength) return i18next.t('validation.default.maxlength', { error: { limit: maxLength } });
  }
  return true;
};

export const decimalString = () => (value) => {
  if (value && value.length && !/^(\d(?:\.?\d)*)?$/.test(value)) {
    return 'Invalid format';
  }
  return true;
};

export const email = () => (value) => {
  if (value && value.length) {
    if (value.length > 64) return i18next.t('validation.default.maxlength', { error: { limit: 64 } });
    if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        value,
      )
    )
      return i18next.t('validation.standard.email');
  }
  return true;
};

export const phone = type => (value) => {
  if (value && value.length) {
    if (value.length > 25) return i18next.t('validation.default.maxlength', { error: { limit: 25 } });
    if (!/^(?:\+\d{1,3})?(?:[() -]?\d){6,}$/.test(value)) return i18next.t(`validation.standard.${type.toLowerCase()}`);
  }
  return true;
};

// TO-DO: Define Date validations
